import { List, ListItem, Skeleton, Stack } from "@mui/material";

const listItemSx = { py: 2, borderBottom: "1px solid", borderColor: "gray.200" };
const rowStackSx = { alignItems: "center", gap: 2, width: "100%" };
const skeletonSx = { borderRadius: "2px" };
const timeSkeletonSx = { ...skeletonSx, flexShrink: 0 };

export const NewsListSkeleton = () => (
    <List sx={{ p: 0 }}>
        <ListItem disablePadding sx={listItemSx}>
            <Stack direction="row" sx={rowStackSx}>
                <Skeleton variant="rectangular" width={40} height="20px" sx={timeSkeletonSx} />
                <Skeleton variant="rectangular" height="20px" width="80%" sx={skeletonSx} />
            </Stack>
        </ListItem>
        <ListItem disablePadding sx={listItemSx}>
            <Stack direction="row" sx={rowStackSx}>
                <Skeleton variant="rectangular" width={40} height="20px" sx={timeSkeletonSx} />
                <Skeleton variant="rectangular" height="20px" width="65%" sx={skeletonSx} />
            </Stack>
        </ListItem>
        <ListItem disablePadding sx={listItemSx}>
            <Stack direction="row" sx={rowStackSx}>
                <Skeleton variant="rectangular" width={40} height="20px" sx={timeSkeletonSx} />
                <Stack sx={{ gap: "1px", width: "87%" }}>
                    <Skeleton variant="rectangular" height="20px" width="100%" sx={skeletonSx} />
                    <Skeleton variant="rectangular" height="20px" width="80%" sx={skeletonSx} />
                </Stack>
            </Stack>
        </ListItem>
    </List>
);
